import { Avatar } from '@mui/material';
import {
  LogEntry,
  LogContent,
  LogHeader,
  UserName,
  LogAction,
  Timestamp,
  LogDetails,
  Value,
} from './styles';
import { format } from 'date-fns';
import { LogEntryType } from './Logs';
import { abyssColors } from '@/theme/colors';

export const LogItem = ({
  log,
  isFirst,
  isLast,
}: {
  log: LogEntryType;
  isFirst: boolean;
  isLast: boolean;
}) => (
  <LogEntry key={log.id} isFirst={isFirst} isLast={isLast}>
    <Avatar
      src={log.user.avatar}
      sx={{
        width: 32,
        height: 32,
        bgcolor: abyssColors.primary[700],
        fontSize: '14px',
        fontWeight: 500,
        marginTop: 1,
      }}
    >
      {log.user.initials}
    </Avatar>

    <LogContent>
      <LogHeader>
        <UserName variant="body1">{log.user.name}</UserName>
        <LogAction variant="body1">{log.action}</LogAction>
        <LogAction variant="body1">
          {log.details.length > 1 ? 'multiple fields' : log.details[0]?.key}
        </LogAction>
      </LogHeader>

      <Timestamp variant="caption">
        {format(new Date(log.timestamp), "dd MMM yyyy 'at' HH:mm")}
      </Timestamp>

      <LogDetails>
        {log.details.map((detail, i) => (
          <Value key={i} variant="body2" isComment={detail.key.toLowerCase() === 'comment'}>
            {detail.to}
          </Value>
        ))}
      </LogDetails>
    </LogContent>
  </LogEntry>
);
